import { render } from "./Addteacher.vue?vue&type=template&id=3fb8de1d"
import script from "./Addteacher.vue?vue&type=script&lang=js"
export * from "./Addteacher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__